import React, { useState } from 'react'
import styled from 'styled-components';
import Icon_NotePen from 'src/assets/images/Icon_NotePen.svg'
import Icon_Trashbin from 'src/assets/images/Icon_Trashbin.svg'
import DateRangePickerAddEtc from './DateRangePickerAddEtc';
import DatePickerAddEtc from './DatePickerAddEtc';
import AddEtcModify from './AddEtcModify';
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore';

const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  width: 720px;
  position:relative;
`

const LabelSpan = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 8px;
    
    padding-top: 8px;
    flex: 1;
    font-size: 18px;
    font-weight: 600;
`

const ElementWrapper = styled.div`
  width: 512px;
  position: relative;
`
const CircleWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  });

const Circle = styled.div<{ isNow?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ isNow }) => (isNow ? '#FFF' : '#508A9C')};
  border: 2px solid #A7C5CD;
  filter: ${({ isNow }) =>
    isNow ? 'drop-shadow(0px 0px 4px rgba(49, 242, 189, 0.8))' : 'none'};
  z-index: 2;
  color: white;
  font-size: 12px;
`;

const Line = styled.div`
  position: absolute;
  height: calc(100% + 8px);
  background-color: #A7C5CD;
  flex-grow: 1;
  margin-top: 0px; // 바로 이어붙이기
  top: 28px;
  border: 1px solid #A7C5CD;
  z-index: -1;
  left: -21px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: 49px;
    min-width: 48px;
    height: 24px;
`

interface Props{
    item: any
    index:number
    isReturn? : boolean
    is_Modify? : boolean
}

const EtcElement = ({item,index, isReturn, is_Modify=true}:Props) => {
    const [ismodify,setIsmodify] = useState(false)
    const [title,setTitle] = useState(isReturn ? item.course_name ? item.course_name:item[0]:item[0])
    const [start_date,setStart_date] = useState(isReturn ? item.start_date? item.start_date:item[1] :item[1])
    const [end_date,setEnd_date] = useState(isReturn ? item.end_date ? item.end_date:item[2]:item[2])
    const removeEtc = ModalAdSheduleAddStore((state)=>state.removeEtc)

    return (
        <LabelWarpper key={index}>
            <Line />
            <div style={{ position: 'absolute', left:'-32px', top:'8px'}}>
                <CircleWrapper>
                <Circle>{index + 2}</Circle>
                </CircleWrapper>
            </div>
            <LabelSpan>
                <span style={{marginRight: is_Modify ? '0px':'40px'}}>
                    {title}
                </span>
                {is_Modify ? <ButtonWrapper>
                    <img src={Icon_NotePen} onClick={()=>setIsmodify(true)}/>
                    <img src={Icon_Trashbin} onClick={()=>removeEtc(index)}/>
                </ButtonWrapper>
                :
                <></>}
            </LabelSpan>
            <ElementWrapper>
                {ismodify ?
                <>
                    <AddEtcModify title='과정 편집' index={index} setModify={setIsmodify} start_date={start_date} setstart_date={setStart_date} end_date={end_date} setend_date={setEnd_date} defaultname={title} set_title={setTitle}/>
                </>
                :
                (end_date === undefined || end_date === '') ?
                    <div style={{ width: '100%', height: '40px', pointerEvents: 'none' }}>
                        <DatePickerAddEtc textAlign='center' start_date={start_date}/>
                    </div>
                    :
                    <div style={{ width: '100%', height: '40px', pointerEvents: 'none' }}>
                        <DateRangePickerAddEtc textAlign='center' start_date={start_date} end_date={end_date}/>
                    </div>
                }
            </ElementWrapper>
        </LabelWarpper>
    )
}

export default EtcElement